import type { ImageSet } from "@b2bportal/core-themes";
import loadingIllustration from "../assets/images/loading-illustration.png";
import logo from "../assets/images/logo.png";
import roomPlaceholder from "../assets/images/room-placeholder.png";

export const images: ImageSet = {
  logo,
  tripsHeadingBackground: "https://fakeimg.pl/800x200/?text=Wide%20Image",
  carLoadingImage: loadingIllustration,
  tripsLoadingImage: loadingIllustration,
  hotelLoadingImage: loadingIllustration,
  roomPlaceholder,
};

export default images;
